import {UIState} from "../../../data/UIState";
import * as moment from "moment-timezone";

const LIMIT_MINUTES = 60;
const LIMIT_HOURS = 60*24;
const LIMIT_DAYS = 60*24*15;

export class Ago {
  visible = '';
  readable = '';

  constructor(when: null|moment.Moment) {
    if(when) {
      //let result = '';
      const minutesAgo = UIState.now.diff(moment(when), 'minute');
      if (0 == minutesAgo) {
        this.readable = this.visible = 'just now';
      } else if (minutesAgo < LIMIT_MINUTES) {
        this.visible = minutesAgo + 'm';
        this.readable = minutesAgo + ' minutes ago';
      } else if (minutesAgo < LIMIT_HOURS) {
        this.visible = Math.floor(minutesAgo / LIMIT_MINUTES) + 'h';
        this.readable = Math.floor(minutesAgo / LIMIT_MINUTES) + ' hours ago';
      } else if (minutesAgo < LIMIT_DAYS) {
        this.visible = Math.floor(minutesAgo / LIMIT_HOURS) + 'd';
        this.readable = Math.floor(minutesAgo / LIMIT_HOURS) + ' days ago';
      } else if (when.get('year') === UIState.now.get('year')) {
        this.visible = when.format("MMM D");
        this.readable = "on " + when.format("MMMM Do");
      } else {
        this.visible = when.format("MMM D, YYYY");
        this.readable = "on " + when.format("MMMM Do, YYYY");
      }
    }
  }
}